import { ComponentRef, Type } from '@angular/core';

import { BarLayoutSection } from './bar-layout-section.enum';

export class BarLayoutSectionInjection<T> {
    component: Type<T>;
    section: BarLayoutSection;
    componentRef: ComponentRef<T>;
}
